import React, { useMemo, useState, useEffect } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { useDispatch, useSelector } from "react-redux";
import { setSortState } from "../../../redux/actions";
import cn from "classnames";

import styles from "./SearchTable.module.css";

export default function SearchTable({
  selectedId,
  setId,
  setViewId,
  setStatusId,
  setTableKey,
  headerColumns,
  dataFromState,
  searchTableSize = 10,
  setPersonType,
  externalStyles = false,
}) {
  const dispatch = useDispatch();
  const sortState = useSelector((state) => {
    const { tableReducer } = state;
    return tableReducer.sortState;
  });
  const [paginationState, setPaginationState] = useState({
    pageIndex: 0,
    pageSize: searchTableSize,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const columns = useMemo(() => headerColumns, [headerColumns]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    gotoPage,
    canPreviousPage,
    pageOptions,
    state: { pageIndex, pageSize, sortBy },
    prepareRow,
  } = useTable(
    {
      columns,
      data: dataFromState,
      initialState: { ...paginationState, sortBy: sortState },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    dispatch(setSortState(sortBy));
  }, [sortBy]);

  useEffect(() => {
    setPaginationState({ pageIndex, pageSize });
  }, [pageIndex, pageSize]);
  useEffect(() => {
    setPaginationState({ pageIndex, pageSize });
  }, []);

  useEffect(() => {
    if (!selectedId) setSelectedRow(null);
  }, [dataFromState]);

  const handleTableClick = (e, rowId) => {
    e.stopPropagation();
    const id = e.currentTarget.dataset.id;
    if (!window.location.pathname.includes("registeroftrainees")) {
      setSelectedRow(rowId);
    }
    switch (true) {
      case e.target.baseURI.includes("smallboatsreg"): {
        setPersonType(Number(e.currentTarget.dataset.persontype));
        setStatusId(e.currentTarget.dataset.status);
        setId(id);
        break;
      }
      case e.target.baseURI.includes("issuing-certificates/applicant-search"): {
        setId(id);
        setPersonType(Number(e.currentTarget.dataset.persontype));
        break;
      }
      case e.target.baseURI.includes("issuing-certificates"): {
        setId(id);
        setStatusId(e.currentTarget.dataset.status);
        break;
      }
      case e.target.baseURI.includes("exchange-certificates"): {
        setId(id);
        setViewId(e.currentTarget.dataset.viewid);
        setStatusId(e.currentTarget.dataset.status);
        break;
      }
      case e.target.baseURI.includes("duplicate-certificates"): {
        setId(id);
        setViewId(e.currentTarget.dataset.viewid);
        setStatusId(e.currentTarget.dataset.status);
        break;
      }
      case e.target.baseURI.includes("certificates"): {
        setId(id);
        setStatusId(e.currentTarget.dataset.status);
        break;
      }
      case e.target.baseURI.includes("smallboats"): {
        setId(id);
        break;
      }
      case e.target.baseURI.includes("dupshipsticket/searchboatcard"): {
        setId(id);
        break;
      }
      case e.target.baseURI.includes("dupshipsticket"): {
        setStatusId(e.currentTarget.dataset.status);
        setId(id);
        break;
      }
      case e.target.baseURI.includes("shipsticket"): {
        setStatusId(e.currentTarget.dataset.status);
        setTableKey(e.currentTarget.dataset.tablekey);
        setId(id);
        break;
      }
      case e.target.baseURI.includes("transportaccidents"): {
        setStatusId(e.currentTarget.dataset.status);
        setId(id);
        break;
      }
      case e.target.baseURI.includes("techexamination/searchboatcard"): {
        setId(id);
        break;
      }
      case e.target.baseURI.includes("techexamination"): {
        setId(id);
        setStatusId(e.currentTarget.dataset.status);
        break;
      }
      case e.target.baseURI.includes("provisioninformation"): {
        setId(id);
        setStatusId(e.currentTarget.dataset.status);
        break;
      }
      default:
        setId(id);
        break;
    }
  };

  const checkLeftNoTitle = () => {
    return headerColumns[0].leftNoTitle === undefined || headerColumns[0].leftNoTitle === false;
  };

  return (
    <>
      {checkLeftNoTitle() && <p className={styles.caption}>Результаты поиска:</p>}
      <div className={styles["content-container"]}>
        <table
          className={cn(styles["table-container"], {
            [externalStyles["table-container"]]: externalStyles,
          })}
          {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    className={`${styles.th_table} ${checkLeftNoTitle() ? "" : styles["text-left-align"]}`}
                    {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    <span>{column.isSorted ? (column.isSortedDesc ? " ▼" : " ▲") : "  "}</span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr
                  data-id={
                    row.original.id || row.original.parkId
                      ? row.original.id || row.original.parkId
                      : row.original.orderNum
                  }
                  data-status={
                    window.location.pathname.includes("smallboatsreg") ||
                    window.location.pathname.includes("dupshipsticket") ||
                    window.location.pathname.includes("shipsticket") ||
                    window.location.pathname.includes("techexamination")
                      ? row.original.statusId
                      : window.location.pathname.includes("transportaccidents")
                      ? row.original.incidentStatus
                      : window.location.pathname.includes("issuing-certificates") ||
                        window.location.pathname.includes("exchange-certificates") ||
                        window.location.pathname.includes("duplicate-certificates")
                      ? row.original.status
                      : window.location.pathname.includes("provisioninformation")
                      ? row.original.statusId
                      : window.location.pathname.includes("certificates")
                      ? row.original.isActive
                      : null
                  }
                  data-viewid={
                    window.location.pathname.includes("exchange-certificates") ||
                    window.location.pathname.includes("duplicate-certificates")
                      ? row.original.idView
                      : null
                  }
                  data-persontype={
                    window.location.pathname.includes("smallboatsreg")
                      ? row.original.unp
                        ? 2
                        : 1
                      : window.location.pathname.includes("issuing-certificates/applicant-search")
                      ? row.original.programId === 1
                        ? 1
                        : 2
                      : null
                    // (window.location.pathname.includes("smallboatsreg") && row.original.unp ? 2 : 1) ||
                    // (window.location.pathname.includes("issuing-certificates/applicant-search") &&
                    // row.original.programId === 1
                    //   ? 1
                    //   : 2)
                  }
                  data-tablekey={window.location.pathname.includes("shipsticket") ? row.original.key : null}
                  onClick={(e) => {
                    handleTableClick(e, row.id);
                  }}
                  className={`${selectedRow === row.id.toString() ? styles["selected"] : ""} ${
                    styles["tr-td"]
                  }`}
                  {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    switch (cell.column.id) {
                      case "index":
                        return (
                          <td
                            className={`${row.original.arrestOrLimit ? styles["td-invalid"] : ""} `}
                            {...cell.getCellProps()}>
                            <div>{row.index + 1}</div>
                          </td>
                        );
                      case "trainingSelfTraining":
                        return (
                          <td
                            className={`${row.original.arrestOrLimit ? styles["td-invalid"] : ""} `}
                            {...cell.getCellProps()}>
                            <div>
                              {cell.value
                                ? "Самоподготовка" +
                                  `${row.original.examType ? `,\n${row.original.examType}` : ""}`
                                : "Обучение" +
                                  `${row.original.examType ? `,\n${row.original.examType}` : ""}`}
                            </div>
                          </td>
                        );
                      default:
                        return (
                          <td
                            // onClickCapture={(e) => {
                            //   handleSetId(e);
                            // }}
                            className={`${row.original.arrestOrLimit ? styles["td-invalid"] : ""} `}
                            {...cell.getCellProps()}>
                            <div className={`${checkLeftNoTitle() ? "" : styles["text-left-align"]}`}>
                              {cell.render("Cell")}
                            </div>
                          </td>
                        );
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {dataFromState.length > 0 && pageOptions.length > 1 ? (
        <div className={styles["pagination"]}>
          <button
            className={styles["pagination-button"]}
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}>
            {"<<"}
          </button>
          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            type="button"
            className={styles["pagination-button"]}>
            {"<"}
          </button>
          {pageOptions.map((page, i) =>
            i < pageIndex + 2 && i > pageIndex - 2 ? (
              <button
                className={styles["pagination-button"]}
                key={i}
                onClick={() => gotoPage(i)}
                style={{
                  fontWeight: pageIndex === i ? "bold" : "normal",
                  color: pageIndex === i ? "white" : "black",
                  backgroundColor: pageIndex === i ? "#BC8653" : "white",
                }}>
                {i + 1}
              </button>
            ) : null,
          )}
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            type="button"
            className={styles["pagination-button"]}>
            {">"}
          </button>
          <button
            className={styles["pagination-button"]}
            onClick={() => gotoPage(Math.ceil(dataFromState.length / searchTableSize) - 1)}
            disabled={!canNextPage}>
            {">>"}
          </button>
        </div>
      ) : null}
    </>
  );
}

export const MemoSearchTable = React.memo(SearchTable);
